import script from "./MainCardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./MainCardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./MainCardSkeleton.vue?vue&type=style&index=0&id=68179746&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68179746"]])

export default __exports__